import {z} from 'zod';

import {InspectionStateConfig, ScopeValues} from '@dms/api/shared';

const MATCH_VALUES = ['every', 'some'] as const satisfies InspectionStateConfig['match'][];

const inspectionParamsSchema = z.object({
  inspectionState: z.union([
    z.string(),
    z.enum(['SKIP']),
    z.object({
      match: z.enum(MATCH_VALUES),
      values: z.array(z.string()),
    }),
  ]),
});

export function evaluateInspectionState(scopes: string[], evaluatorParams: ScopeValues) {
  const {inspectionState} = validateInspectionEvaluatorParams(evaluatorParams);

  if (typeof inspectionState === 'string') {
    if (inspectionState === 'SKIP') {
      return true;
    }
    return scopes.includes(inspectionState);
  }

  if (inspectionState.match === 'every') {
    return inspectionState.values.every((state) => scopes.includes(state));
  }

  return inspectionState.values.some((state) => scopes.includes(state));
}

export function validateInspectionEvaluatorParams(evaluatorParams: ScopeValues | null) {
  return inspectionParamsSchema.parse(evaluatorParams);
}
